import classNames from "classnames";
import React from "react";
import styles from "./SegmentedControl.scss";

/**
 * Pill-shaped radio group for switching between a few options
 * @param options [{ value, label, append }] – `append` renders a small highlighted note after the label
 * @param size – "small" for compact toolbars
 */
export const SegmentedControl = ({ options, value, onChange, label, size, className }) => {
    return (
        <div
            className={classNames(styles.base, { [styles.sizeSmall]: size === "small" }, className)}
            role="radiogroup"
            aria-label={label}
        >
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    role="radio"
                    aria-checked={option.value === value}
                    className={classNames(styles.option, { [styles.active]: option.value === value })}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                    {option.append ? <span className={styles.append}>{option.append}</span> : null}
                </button>
            ))}
        </div>
    );
};
